import api from "./api";

const urlB64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const subscribeToPush = async () => {
  if (!pushSupported()) throw new Error("Notifications push non supportées par ce navigateur");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permission de notifications refusée");
  const reg = await navigator.serviceWorker.register("/sw.js");
  const { data } = await api.get("/push/vapid-key");
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlB64ToUint8Array(data.public_key),
  });
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return sub;
};

export const ensurePushSubscription = async () => {
  if (!pushSupported() || Notification.permission !== "granted") return;
  try {
    const reg = (await navigator.serviceWorker.getRegistration("/sw.js")) || (await navigator.serviceWorker.register("/sw.js"));
    const sub = await reg.pushManager.getSubscription();
    if (sub) await api.post("/push/subscribe", { subscription: sub.toJSON() });
  } catch (e) {
    /* silencieux : l'utilisateur réactivera depuis son profil */
  }
};
